// Role constants for authorization
export const Role = {
  SuperAdmin: "Super Admin",
  FirmAdmin: "Firm Admin",
  OrderAdmin: "Order Admin",
};

// All roles array for convenience
export const AllRoles = [Role.SuperAdmin, Role.FirmAdmin, Role.OrderAdmin];

// Admin roles (Super Admin and Firm Admin)
export const AdminRoles = [Role.SuperAdmin, Role.FirmAdmin];

export default Role;

